import { Component } from 'preact';
import { ContentBlock, ContentContext } from './content.js';
import { Context } from '../../common/context.js';
import { Blog, BlogCategory, ContentExtras } from '../../common/data/content.js';
import dayjs from 'dayjs';
import { Maybe } from '../../common/data.js';
import { Icon } from './icons.js';
import { Picture } from './image.js';
import { getEventValue } from '../lib/util.js';

export interface BlogIndexWrapperProps {
	context: Context;
	category: BlogCategory;
	posts: Blog[];
	extras: ContentExtras;
	urlCategory: Maybe<string>;
	blogCategories: Pick<BlogCategory, 'url' | 'name'>[];
}

interface BlogIndexWrapperState {
	selectedCategory?: Maybe<string>;
}

export class BlogIndexWrapper extends Component<BlogIndexWrapperProps, BlogIndexWrapperState> {
	
	setCategory = (e: Event) => {
		const selectedCategory = getEventValue(e);
		location.href = `/blog/${selectedCategory}`.replace(/\/$/, '');
	};
	
	componentDidMount() {
		this.setState({ selectedCategory: this.props.urlCategory });
	}
	
	render() {
		const { context, category, posts, extras, urlCategory, blogCategories } = this.props;
		const { domain } = context;
		const prefix = urlCategory ? `/blog/${urlCategory}` : `/blog`;
		return <main class="blog">
			<div className="blog-categories">
				<span className="blog-categories__title">Blog Categories </span>
				<select
					class="blog-categories__dropdown"
					name="status_filter"
					onChange={this.setCategory}
					value={this.state.selectedCategory ?? ''}
				>
					<option value="">All</option>
					{blogCategories.map(v => <option value={v.url!}>{v.name}</option>)}
				</select>
			</div>
			<ContentContext.Provider value={{
				target: ['web'],
				domain,
				website: `https://${context.domain.host}`,
				extras,
				link: s => s,
				image: s => s,
			}}>
				<h1>{category.name}</h1>
				{posts.map(post => <article className="blog-index-entry">
					<div className="blog-index-entry__image">
						{post.image && <a href={`${prefix}/${post.url}`}><Picture alt={post.title} src={`/data/blogs/${post.image}`}/></a>}
					</div>
					<div className="blog-index-entry__content">
						<div className="blog-index-entry__title"><a
							href={`${prefix}/${post.url}`}>{post.title}</a></div>
						<div className="blog-index-entry__detail">
							<span className="blog-index-entry__author">By <span
								className="blog-index-entry__author-name">{post.author}</span></span>
							<span>|</span>
							<span className="blog-index-entry__date">{post.posted && dayjs(post.posted).format('MMM DD, YYYY')}</span>
							{post.post_updated && <>
								<span>|</span>
								<span className="blog-index-entry__date">Updated {dayjs(post.post_updated).format('MMM DD, YYYY')}</span>
							</>}
						</div>
						{post.abstract && <ContentBlock item={post.abstract}/>}
						<div className="blog-index-entry__action">
							<a className="blog-index-entry__btn" href={`${prefix}/${post.url}`}> Continue
								Reading </a>
						</div>
					</div>
				</article>)}
			</ContentContext.Provider>
		</main>;
	}
	
}

export interface BlogPostWrapperProps {
	context: Context;
	post: Blog;
	extras: ContentExtras;
	prevPost: Maybe<Pick<Blog, 'url' | 'title'>>;
	nextPost: Maybe<Pick<Blog, 'url' | 'title'>>;
	urlCategory: Maybe<string>;
}

interface BlogPostWrapperState {
}

export class BlogPostWrapper extends Component<BlogPostWrapperProps, BlogPostWrapperState> {
	
	render() {
		const { context, post, extras, prevPost, nextPost, urlCategory } = this.props;
		const { domain } = context;
		const prefix = urlCategory ? `/blog/${urlCategory}` : `/blog`;
		return <article class="blog" itemScope={true} itemType="https://schema.org/NewsArticle">
			<nav className="blog__index-link">
				<a href="/blog"><Icon name="arrow-left"/><span>{domain.brand_name} Blog</span></a>
			</nav>
			<div className="blog-post">
				<div className="blog-post__title" itemProp="headline">{post.title}</div>
				<div className="blog-post__date-author">
					{post.posted && <div>
						<data className="blog-post__date-value" itemProp="datePublished" value={dayjs(post.posted).format()}>
							{dayjs(post.posted).format('MMM DD, YYYY')}
						</data>
					</div>}
					{post.post_updated && <div>
						{'Updated '}
						<data className="blog-post__date-value" itemProp="datePublished" value={dayjs(post.post_updated).format()}>
							{dayjs(post.post_updated).format('MMM DD, YYYY')}
						</data>
					</div>}
					<div
						className="blog-post__author"
						itemProp="author"
						itemScope={true}
						itemType="https://schema.org/Person"
					>
						By <span className="blog-post__author-name" itemProp="name">{post.author}</span>
					</div>
				</div>
				{/*<div className="blog-post__image">{post?.image && <img alt={'Alt text'} src={`/data/blogs/${post.image}`} />}</div>*/}
				<meta itemProp="image" content={`https://${domain.host}/data/blogs/${post.image}`}/>
			</div>
			<div className="blog-post__content">
				<ContentContext.Provider value={{
					target: ['web'],
					domain,
					website: `https://${context.domain.host}`,
					extras,
					link: s => s,
					image: s => s,
				}}>
					<ContentBlock item={post.content}/>
				</ContentContext.Provider>
			</div>
			<nav className="blog__prev-next-link">
				<span>
					<a className="blog__prev-link" href={`${prefix}/${prevPost?.url || ''}`}>{prevPost?.url
						? <><Icon name="arrow-left"/>Previous Post: <span>{prevPost.title}</span></>
						: ''}</a>
				</span>
				<span>
					<a className="blog__next-link" href={`${prefix}/${nextPost?.url || ''}`}>{nextPost?.url
						? <>Next Post: <span>{nextPost.title}</span> <Icon name="arrow-right"/></>
						: ''}</a>
				</span>
			</nav>
		</article>;
	}
}
